<template>
 <div class="p-4">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-12 text-left">
              <h4>Terms of Use</h4>
          </div>
        </div>
      </div>
      <div class="card-body">
        <b-row>
            <b-col lg="12">
                <h4 class="mt-3">Vehicle Solutions Australia Website Terms of Use</h4>
                <p class="mt-1">
                    This web site is owned and operated by Vehicle Solutions Australia Pty Ltd and will be referred to as 
                    “We”, “our” and “us” in this Terms of Use policy. By using this site, you agree to the Terms of Use Policy of this web site 
                    (“the website”), which is set out on this web site page.
                </p>
                <p>
                    When using this web site, you agree to be legally bound by these terms and conditions as they may be modified and posted 
                    to our web site from time to time. Without prejudice to the above, by using or accessing our website, you agree to be legally 
                    bound by these terms and conditions of use as they apply to your use of or access to our website. If you do not wish to be 
                    bound by these terms and conditions then you may not use our website.
                </p>
                <p>
                    When requested you must ensure that the personal information you provide is accurate and complete and that all requests 
                    contain your correct name, address and other requested details. For more information about how we deal with your personal 
                    information, please read our privacy policy. Unless otherwise specified the materials published on our web site are presented 
                    solely for your private, personal and non-commercial use.
                </p>
                <p>
                    We have used all reasonable endeavours to ensure that our web site complies with Australian law. However, we make no 
                    representations that the materials on our web site are appropriate or available for use in locations outside of Australia. 
                    We make no warranties, expressed or implied that making our service available in any particular jurisdiction outside of
                    Australia is permitted under any applicable non-Australian laws or regulations. Accordingly, if making the services or 
                    any part thereof available in your jurisdiction or to you (by reason of nationality, residence or otherwise) is prohibited, 
                    those services are not offered for sale to you. You accept that if you are resident outside of Australia, you must satisfy 
                    yourself that you are lawfully able to purchase the Products. We accept no liability, to the extent permitted by applicable law, 
                    for any quotes, pricing, calculations, costs, losses, or damages resulting from or related to the pricing, calculations or 
                    purchase or attempted purchase of the Products by persons in jurisdictions outside of Australia or who are nominees of or 
                    trustees for citizens, residents or nationals of other countries.
                </p>
                <h4 class="mt-4">Copyright & Monitoring</h4>
                <p class="mt-1">
                    The content of this web site is protected by copyright laws, a Trade Mark, intellectual property rights and an Australia 
                    Innovation Patent. We, or other third-party licensees, are the owner of these rights. All product and company names and logos 
                    mentioned on our web site are the Trade Marks, service marks or trading names of their respective owners, including us. 
                    You may download material from our web site for the sole purpose of using it as an information resource. However, you may not 
                    modify, copy, reproduce, republish, upload, post, transmit or distribute, by any means or in any manner, any material or 
                    information on or downloaded from our web site including, but not limited to text, graphics, video, messages, code and/or 
                    software without our prior written consent, except where expressly invited to do so, for example in order to complete any 
                    test or questionnaire.
                </p>
                <h4 class="mt-4">Third Party Sites</h4>
                <p class="mt-1">We make no representations about any third-party sites which you access directly from our web site or which may link to our web site. 
                    You understand that these sites are independent from Vehicle Solutions Australia and that we have no control over the content or 
                    availability of that web site. In addition, a link to any other site does not mean that we endorse or accept any responsibility 
                    for the content, or the use of, such a web site and shall not be liable for any loss or damage caused or alleged to be caused by 
                    or in connection with use of or reliance on any content, goods or services available on or through any other web or resource.
                </p>
                <h4 class="mt-4">Availability of our Web Site</h4>
                <p class="mt-1">We will try to make our web site available but cannot guarantee that our web site will operate continuously or without 
                    interruptions or be error free and can accept no liability for its unavailability. You must not attempt to interfere with 
                    the proper working of our web site and, in particular, you must not attempt to circumvent security, tamper with, hack into, 
                    or otherwise disrupt any computer system, server, web site, router or any other internet connected device. We reserve the 
                    right to alter, suspend or discontinue any aspect of our website or the content or services available through it, including your 
                    access to it. Unless explicitly stated, any new features including new content and/or the sale of new products and/or the 
                    release of new software tools or resources shall be subject to these terms and conditions. We are committed to safeguarding 
                    the privacy of our users. We take your privacy very seriously and it is important to us that you can use and enjoy our 
                    website without having to compromise your privacy in any way. For more information, please see our privacy policy.
                </p>
                <h4 class="mt-4">Standard Indemnity</h4>
                <p class="mt-1">
                    On accepting these terms and conditions you hereby indemnify Vehicle Solutions Australia and undertake to keep us indemnified 
                    against any losses, damages, costs, liabilities and expenses, plus, without limitation legal expenses and any amounts paid by 
                    us to a third party in settlement of a claim or dispute on the advice of our legal advisors incurred by Vehicle Solutions 
                    Australia arising out of any breach by you of any provision of these terms of use, or arising out of any claim that you 
                    have breached any provision of these terms of use.
                </p>
            </b-col>
        </b-row>
      </div>
    </div>
 </div>



  
</template>
<script>
import { findash } from '../../config/pluginInit'

export default {
  name: 'BlankPage',
  mounted () {
    findash.index()
  }
}
</script>
